import { COLORS } from '../../../config/designSystem/Colors';
import { FC } from 'react';
import { SPACING } from '../../../config/designSystem/Spacing';
import { StyleSheet, Text, TouchableOpacity } from 'react-native';
import { mainTypoBold } from '../../../config/designSystem/typography';
import { observer } from 'mobx-react';

interface ChipProps {
  label: string;
  onPress?: () => void;
  selected?: boolean;
  /**
   * outline: bordered chip (default, legacy surveys)
   * soft: filled light chip from the mood diary design (figma: Activities & Challenges pt1)
   */
  variant?: 'outline' | 'soft';
}

const _Chip: FC<ChipProps> = ({ label, onPress, selected, variant = 'outline' }) => {
  return (
    <TouchableOpacity
      style={[
        styles.TouchableOpacity,
        variant === 'soft' ? styles.TouchableOpacitySoft : {},
        selected ? styles.TouchableOpacitySelected : {},
      ]}
      onPress={onPress}
    >
      <Text
        // figma: deprecated buttons & links
        style={[
          styles.Text,
          variant === 'soft' ? styles.TextSoft : {},
          selected ? styles.TextSelected : {},
        ]}
      >
        {label}
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  TouchableOpacity: {
    display: 'flex',
    flexDirection: 'row',
    minWidth: SPACING['sp-80'],
    paddingVertical: SPACING['sp-8'],
    paddingHorizontal: SPACING['sp-16'],
    justifyContent: 'center',
    alignItems: 'center',
    gap: SPACING['sp-8'],
    borderRadius: 999,
    borderWidth: SPACING['sp-px'],
    borderColor: COLORS.content.accent,
    backgroundColor: COLORS.surface.contrast,
  },
  TouchableOpacitySoft: {
    minWidth: 0,
    borderWidth: 0,
    backgroundColor: COLORS.surface.accent,
  },
  TouchableOpacitySelected: {
    backgroundColor: COLORS.surface['inverse-primary'],
  },
  Text: {
    color: COLORS.content.accent,
    textAlign: 'center',
    fontFamily: mainTypoBold,
    fontSize: 13,
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 16,
    letterSpacing: 0.182,
  },
  TextSoft: {
    color: COLORS.content.primary,
  },
  TextSelected: {
    color: COLORS.content['inverse-primary'],
  },
});

const Chip = observer(_Chip);

Chip.displayName = 'Chip';
_Chip.displayName = 'Chip';

export { Chip, _Chip };
